import { Box, Flex, Heading, Text, SimpleGrid } from "@chakra-ui/react";
import Reveal from "../../components/motion";
import { BobContent } from "../../data/bobContent";

const BobValue = ({ value, trust }: { value: BobContent["value"]; trust: BobContent["trust"] }) => (
  <Box as="section" py={{ base: 16, md: 24 }} bg="chalk.200">
    <Box maxW="1200px" mx="auto" px={{ base: 5, md: 8 }} mb={{ base: 16, md: 20 }}>
      <Reveal mb={10} maxW="640px">
        <Text color="bob.300" fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
          {value.eyebrow}
        </Text>
        <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }}>
          {value.heading}
        </Heading>
      </Reveal>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
        {value.items.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.06}>
            <Flex direction="column" h="100%" bg="chalk.50" border="1px solid" borderColor="chalk.400" borderRadius="xl" p={6}>
              <Heading as="h3" fontFamily="heading" fontSize="lg" mb={2} color="ink.900">
                {item.title}
              </Heading>
              <Text fontSize="sm" color="slate.700">
                {item.description}
              </Text>
            </Flex>
          </Reveal>
        ))}
      </SimpleGrid>
    </Box>

    <Box maxW="1200px" mx="auto" px={{ base: 5, md: 8 }}>
      <Reveal mb={10} maxW="640px">
        <Text color="bob.300" fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
          {trust.eyebrow}
        </Text>
        <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }}>
          {trust.heading}
        </Heading>
      </Reveal>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
        {trust.items.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08}>
            <Box>
              <Heading as="h3" fontFamily="heading" fontSize="md" mb={2}>
                {item.title}
              </Heading>
              <Text fontSize="sm" color="slate.700">
                {item.description}
              </Text>
            </Box>
          </Reveal>
        ))}
      </SimpleGrid>
    </Box>
  </Box>
);

export default BobValue;
